<template>
  <v-app-bar app dir="rtl">
    <v-app-bar-nav-icon @click="$store.commit('toggleDrawer')" />
    <v-spacer></v-spacer>
    <div v-if="!$store.state.isProduction" style="background: red">..סביבת בדיקות..</div>
    <v-img contain src="https://gdragon-public.s3.us-east-2.amazonaws.com/images/gdragon-logo.png" max-width="100"
      max-height="100" />
    <div v-if="!$store.state.isProduction" style="background: red">..test enviroment..</div>
    <v-spacer></v-spacer>
    <div>
      <vk-button v-if="!isLoggedIn" type="primary" v-on:click="toggleGuestMode">
        {{ leftButtonText }}
      </vk-button>
      <vk-button v-if="isLoggedIn" type="danger" @click="signOut">התנתק</vk-button>
      <!-- <amplify-sign-out v-if="isLoggedIn" button-text="התנתק"></amplify-sign-out> -->
    </div>
    <vk-modal :show="show" center size="container" class="terms-of-user-modal">
      <vk-modal-title>תנאי שימוש</vk-modal-title>
      <div class="content">
        <p>
          אתר האינטרנט ו/או הפורטל של <b>גולדן סוכנויות אוטובוסים ושות׳</b> (להלן: ״החברה״) הינו בבעלותה.<br>
          אין לעשות שימוש בנתונים ו/או במידע אלא בהסכמת החברה.<br>
          שימוש באתר לצרכי קבלת מידע ו/או לכל צורך אחר מהווה הסכמה מצידך להוראות ולתנאים<br>
          המפורטים להלן:
        </p>
        <p>
          התכנים המובאים באתר זה מובאים לצורך הסבר ומידע בלבד, ואין בהם משום התחייבות<br>
          מצד החברה ו/או ייעוץ, ו/או המלצה ביחס לפעולות כלשהן, לרבות כדאיותן ו/או עיתוי<br>
          הביצוע. החברה לא תישא בכל אחריות מכל סוג שהוא לגבי החלטות אשר יקבל או יעשה<br>
          המשתמש בהסתמך על המידע המסופק על ידי ובאמצעות האתר.
        </p>
        <p>
          יתכן כי נפלו טעויות או שיבושים ו/או אי דיוקים במידע המופיע באתר. ט.ל.ח. אין החברה<br>
          תהא אחראית לנזק שעלול להיגרם בשל טעויות כאמור. שימוש בטפסים המופיעים באתר<br>
          כפוף לאפשרות שינויים ואפשר שיופיעו טפסים שאינם עדכניים. החברה לא תהיה אחראית<br>
          לכל נזק ישיר ו/או עקיף שעלול להיגרם למשתמש עקב הסתמכות על מידע זה והעושה בו<br>
          שימוש עושה זאת על אחריותו בלבד.
        </p>
        <p>
          המשתמש מצהיר ומתחייב כי כל שימוש שיעשה במידע ו/או בתוכן הינו על אחריותו<br>
          הבלעדית.<br>
          בכל מקרה של סתירה או אי התאמה בין המידע המופיע באתר ו/או בפורטל לבין מידע ו/או<br>
          תוכן כפי שמופיע בפרסומים רשמיים או מקוריים בכתב, רק המידע ו/או התוכן המופיע<br>
          בפרסומים הרשמיים או המקוריים כאמור, יחשב כנכון.
        </p>
        <p>
          האמור בתנאי שימוש מנוסח מטעמי נוחות בלשון זכר, אולם הוא מתייחס לשני המינים<br>
          בצורה שווה.
        </p>
      </div>
      <vk-grid>
        <vk-button type="danger" v-on:click="denyTerms">לא מסכים/ה</vk-button>
        <v-spacer></v-spacer>
        <vk-button type="primary" v-on:click="acceptTerms">מסכים/ה</vk-button>
      </vk-grid>
    </vk-modal>
  </v-app-bar>
</template>

<script>
import { mapState } from "vuex";
import { Auth } from 'aws-amplify';
import { onAuthUIStateChange } from '@aws-amplify/ui-components'

export default {
  name: 'Header',
  data: function () {
    return {
      show: false,
      acceptedTerms: false
    }
  },
  computed: {
    ...mapState({
      isGuestMode: (state) => state.isGuestMode,
      isLoggedIn: (state) => state.authState === 'signedin'
    }),
    leftButtonText: function () {
      return this.isGuestMode ? 'התחבר' : 'המשך כאורח';
    },
  },
  created() {
    onAuthUIStateChange((authState) => {
      if (authState === 'signedin') {
        this.show = true;
      }
    })
  },
  methods: {
    toggleGuestMode() {
      if (!this.isGuestMode) {
        this.show = true;
        return;
      }

      this.$store.commit("setGuestMode", !this.isGuestMode);
    },
    acceptTerms() {
      this.acceptedTerms = true;
      this.show = false;
      this.$store.commit("setGuestMode", !this.isLoggedIn);
      localStorage.setItem('acceptedTerms', "true");
    },
    denyTerms() {
      this.acceptedTerms = false;
      this.show = false;
      Auth.signOut();
      localStorage.setItem('acceptedTerms', "false");
    },
    signOut() {
      this.$gtag.event('sign_out', { user: Auth.user })
      Auth.signOut();
      this.$store.commit('setUser', null);

      setTimeout(() => {
        window.open('https://docs.google.com/forms/d/11wf4yPKwsXn2WDFmGB8oTHHqeGsu_ZdhBdSJL3GlnTw');
      }, 1500);
    }
  }
}
</script>

<style>
.uk-grid {
  margin: 0 !important;
  justify-content: space-around;
}

.terms-of-user-modal .uk-modal-body .content {
  max-height: 400px;
  overflow: auto;
  text-align: right;
  direction: rtl;
  font-size: 1.1rem;
  line-height: 1.5;
  padding: 0 10px;
  margin: 10px 0;
}

.terms-of-user-modal .uk-modal-body .content p {
  display: block;
  content: " ";
  margin: 10px 0;
}

.terms-of-user-modal .uk-modal-body .content::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.terms-of-user-modal .uk-modal-body .content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.terms-of-user-modal .uk-modal-body .content::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.terms-of-user-modal .uk-modal-body .content::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
